import {Component, OnInit} from '@angular/core';
import {PublicNavigationComponent} from "../public-navigation/public-navigation.component";
import {PublicFooterComponent} from "../footer/footer.component";

@Component({
    selector: 'app-imprint',
    templateUrl: './imprint.component.html',
    styleUrl: './imprint.component.scss',
    imports: [
        PublicNavigationComponent,
        PublicFooterComponent
    ]
})
export class ImprintComponent implements OnInit {

    currentYear!: number;

    ngOnInit(): void {
        this.currentYear = new Date().getFullYear();
    }

}
